import { inject } from '@angular/core';
import { ApolloClientOptions, InMemoryCache, split } from '@apollo/client/core';
import { HttpLink } from 'apollo-angular/http';
import { GraphQLWsLink } from '@apollo/client/link/subscriptions';
import { createClient } from 'graphql-ws';
import { getMainDefinition } from '@apollo/client/utilities';
import { provideApollo } from 'apollo-angular';
import { PLATFORM_ID } from '@angular/core';
import { isPlatformBrowser } from '@angular/common';
import { provideHttpClient, withFetch, withInterceptors } from '@angular/common/http';
import { environment } from '../environments/environment';
import { authInterceptor } from './core/interceptors/auth.interceptor';
import { AuthService } from './core/services/auth.service';

const httpUri = environment.gqlHttpUrl;
const wsUri = environment.gqlWsUrl;

export function apolloOptionsFactory(): ApolloClientOptions {
  const httpLink = inject(HttpLink);
  const platformId = inject(PLATFORM_ID);
  const authService = inject(AuthService);

  const http = httpLink.create({ uri: httpUri });

  if (isPlatformBrowser(platformId)) {
    const ws = new GraphQLWsLink(
      createClient({
        url: wsUri,
        connectionParams: () => {
          const token = authService.getToken();
          return token ? { Authorization: `Bearer ${token}` } : {};
        },
      }),
    );

    const link = split(
      ({ query }) => {
        const definition = getMainDefinition(query);
        return (
          definition.kind === 'OperationDefinition' && definition.operation === 'subscription'
        );
      },
      ws,
      http,
    );

    return {
      link,
      cache: new InMemoryCache(),
    };
  }

  return {
    link: http,
    cache: new InMemoryCache(),
  };
}

export const graphqlProviders = [
  provideHttpClient(withFetch(), withInterceptors([authInterceptor])),
  provideApollo(apolloOptionsFactory),
];
